import { writable } from 'svelte/store';
import firebase from './firebase';
export const user = writable(firebase.auth().currentUser);
firebase.auth().onAuthStateChanged(user.set);
export const requests = writable([]);
export const meetings = writable([]);
export const error = writable(null);
export const feedback = writable(null);
